var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-theme-provider",
    {
      attrs: {
        dark: _vm.effectiveAppearance === "dark",
        light: _vm.effectiveAppearance === "light"
      }
    },
    [
      _vm.agreement
        ? _c(
            "div",
            {
              key: _vm.agreement.id,
              staticClass: "agreement-builder",
              class: {
                "brand-agreement": _vm.branding,
                "agreement-builder--frame": _vm.inFrame,
                "agreement-builder--headerless": !_vm.showHeader,
                "agreement-builder--paged": _vm.paged
              },
              style:
                "--v-zoom: " +
                _vm.zoom / 100 +
                "; " +
                _vm.styles +
                "; " +
                _vm.brandingStyle
            },
            [
              _vm.paged
                ? _c(
                    "div",
                    {
                      staticClass: "agreement-progress d-print-none",
                      attrs: {
                        role: "progressbar",
                        "aria-valuemin": "0",
                        "aria-valuemax": _vm.agreement.pages.length,
                        "aria-valuenow": _vm.currentPage + 1,
                        "aria-label": _vm.pageProgressLabel
                      }
                    },
                    [_c("span", { style: "width: " + _vm.progress + "%" })]
                  )
                : _vm._e(),
              _vm.showHeader
                ? _c("div", { staticClass: "header-area" }, [
                    _vm.$vuetify.breakpoint.mdAndUp
                      ? _c("div", { staticClass: "header-left" }, [
                          _c(
                            "span",
                            { staticClass: "agreement-mark" },
                            [
                              _c("portal-icon", {
                                attrs: { name: "handshake", size: 20 }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "agreement-name",
                              style:
                                "font-family: '" +
                                _vm.agreement.styles.h1.fontFamily +
                                "'"
                            },
                            [_vm._v(_vm._s(_vm.agreement.name))]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "agreement-icon-button d-print-none",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.$t("proposals.print-save-pdf")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("print")
                                }
                              }
                            },
                            [
                              _c("portal-icon", {
                                attrs: { name: "file-down", size: 19 }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm.signer
                      ? _c("div", { staticClass: "header-right" }, [
                          _vm.showFinishWarning && !_vm.paged
                            ? _c(
                                "span",
                                { staticClass: "finish-warning" },
                                [
                                  _c("portal-icon", {
                                    attrs: { name: "arrow-right", size: 22 }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.signer.locked && !_vm.paged
                            ? _c(
                                "button",
                                {
                                  staticClass: "agreement-finish",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.packageOffersLoading
                                  },
                                  on: { click: _vm.finalize }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      style:
                                        "font-family: '" +
                                        _vm.agreement.styles.h1.fontFamily +
                                        "'"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.agreement.settings.finishedButton
                                            ? _vm.agreement.settings
                                                .finishedButton
                                            : "Finish"
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm.signer.locked
                            ? _c(
                                "div",
                                { staticClass: "agreement-complete" },
                                [
                                  _c("portal-icon", {
                                    attrs: { name: "circle-check", size: 18 }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      style:
                                        "font-family: '" +
                                        _vm.agreement.styles.h1.fontFamily +
                                        "'"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.DateTime.fromISO(
                                            _vm.signer.timestamp
                                          ).toLocaleString(
                                            _vm.DateTime.DATETIME_MED
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _c("div", { staticClass: "agreement-content row-format" }, [
                !_vm.inFrame &&
                _vm.indexedPages.length &&
                _vm.$vuetify.breakpoint.mdAndUp
                  ? _c(
                      "div",
                      { staticClass: "agreement-index column-format" },
                      [
                        _c(
                          "ul",
                          { staticClass: "agreement-index__list" },
                          _vm._l(_vm.indexedPages, function(page) {
                            return _c(
                              "li",
                              {
                                key: page.index,
                                staticClass: "nav-link",
                                class: {
                                  "nav-link--current":
                                    _vm.paged && page.index === _vm.currentPage
                                },
                                style:
                                  "font-family: '" +
                                  _vm.agreement.styles.h1.fontFamily +
                                  "'",
                                on: {
                                  click: function($event) {
                                    return _vm.scrollToPage(page.index)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "agreement-index__number" },
                                  [_vm._v(_vm._s(page.index + 1))]
                                ),
                                _vm._v(" " + _vm._s(page.title) + " ")
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "agreement-page-area show-scrollbar",
                    class: { "agreement-page-area--paged": _vm.paged },
                    attrs: { id: "page-area" }
                  },
                  [
                    _c("div", { staticClass: "zoom agreement-pages" }, [
                      _c(
                        "div",
                        { attrs: { id: "print-area" } },
                        _vm._l(_vm.agreement.pages, function(page, index) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.paged || index === _vm.currentPage,
                                  expression: "!paged || index === currentPage"
                                }
                              ],
                              key: page.id,
                              staticClass: "column-format centered",
                              attrs: { id: "page-" + index }
                            },
                            [
                              _c("page", {
                                ref: "page-" + index,
                                refInFor: true,
                                attrs: {
                                  id: "page-" + index,
                                  "page-index": index,
                                  agreement: _vm.agreement,
                                  "mce-config": {},
                                  "client-mode": _vm.clientMode,
                                  signer: _vm.signer,
                                  "edit-mode": false,
                                  "template-mode": false,
                                  tokens: _vm.tokens,
                                  "page-width": _vm.pageWidth,
                                  "viewer-service": _vm.viewerService,
                                  "in-frame": _vm.inFrame
                                },
                                on: {
                                  "container-item-signed": function($event) {
                                    return _vm.itemSigned(page, $event)
                                  },
                                  signed: function($event) {
                                    return _vm.itemSigned(page, $event)
                                  },
                                  "package-offer-quote-state":
                                    _vm.setPackageOfferQuoteState
                                }
                              }),
                              _c("div", { staticClass: "page-break" })
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm.signer && !_vm.paged
                        ? _c(
                            "div",
                            { staticClass: "row-format centered my-4" },
                            [
                              !_vm.signer.locked
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "agreement-finish agreement-finish--large",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.packageOffersLoading
                                      },
                                      on: { click: _vm.finalize }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style:
                                            "font-family: '" +
                                            _vm.agreement.styles.h1.fontFamily +
                                            "'"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.agreement.settings
                                                .finishedButton
                                                ? _vm.agreement.settings
                                                    .finishedButton
                                                : "Finish"
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm.paged
                      ? _c(
                          "div",
                          {
                            staticClass: "agreement-page-nav-bar d-print-none"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "agreement-page-nav",
                                class:
                                  _vm.inFrame || _vm.pageWidth <= 800
                                    ? "px-3"
                                    : "px-12",
                                style: "max-width: " + _vm.pageNavWidth
                              },
                              [
                                _vm.currentPage > 0
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "agreement-back",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.goToPage(
                                              _vm.currentPage - 1
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("portal-icon", {
                                          attrs: {
                                            name: "arrow-left",
                                            size: 18
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            style:
                                              "font-family: '" +
                                              _vm.agreement.styles.h1
                                                .fontFamily +
                                              "'"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.agreement.settings
                                                  .previousPageButton ||
                                                  _vm.$t("proposals.page-back")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _c("span"),
                                _c(
                                  "span",
                                  { staticClass: "agreement-page-count" },
                                  [_vm._v(_vm._s(_vm.pageCountLabel))]
                                ),
                                !_vm.lastPage
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "agreement-finish agreement-finish--large agreement-next",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.goToPage(
                                              _vm.currentPage + 1
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            style:
                                              "font-family: '" +
                                              _vm.agreement.styles.h1
                                                .fontFamily +
                                              "'"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.agreement.settings
                                                  .nextPageButton ||
                                                  _vm.$t("proposals.page-next")
                                              )
                                            )
                                          ]
                                        ),
                                        _c("portal-icon", {
                                          attrs: {
                                            name: "arrow-right",
                                            size: 18
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm.signer && !_vm.signer.locked
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "agreement-finish agreement-finish--large agreement-next",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.packageOffersLoading
                                        },
                                        on: { click: _vm.finalize }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            style:
                                              "font-family: '" +
                                              _vm.agreement.styles.h1
                                                .fontFamily +
                                              "'"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.agreement.settings
                                                  .finishedButton
                                                  ? _vm.agreement.settings
                                                      .finishedButton
                                                  : "Finish"
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm.signer && _vm.signer.locked
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "agreement-page-nav-done"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "agreement-complete" },
                                          [
                                            _c("portal-icon", {
                                              attrs: {
                                                name: "circle-check",
                                                size: 18
                                              }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                style:
                                                  "font-family: '" +
                                                  _vm.agreement.styles.h1
                                                    .fontFamily +
                                                  "'"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.DateTime.fromISO(
                                                      _vm.signer.timestamp
                                                    ).toLocaleString(
                                                      _vm.DateTime.DATETIME_MED
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.agreement.fullyExecuted
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "agreement-icon-button",
                                                attrs: {
                                                  type: "button",
                                                  "aria-label": _vm.$t(
                                                    "proposals.print-save-pdf"
                                                  ),
                                                  title: _vm.$t(
                                                    "proposals.print-save-pdf"
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$emit("print")
                                                  }
                                                }
                                              },
                                              [
                                                _c("portal-icon", {
                                                  attrs: {
                                                    name: "file-down",
                                                    size: 19
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _c("span")
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _vm.agreement.styles.pageSize !== "RESPONSIVE"
                ? _c(
                    "div",
                    {
                      staticClass: "agreement-zoom d-print-none",
                      class: { "agreement-zoom--raised": _vm.paged }
                    },
                    [
                      _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.zoomOut()
                            }
                          }
                        },
                        [
                          _c("portal-icon", {
                            attrs: { name: "zoom-out", size: 18 }
                          })
                        ],
                        1
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.zoom) + "%")]),
                      _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.zoomIn()
                            }
                          }
                        },
                        [
                          _c("portal-icon", {
                            attrs: { name: "zoom-in", size: 18 }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }